import { useEffect, useState } from 'react';
import { extApi } from '../api/extensibilityClient';

export function DependencyGraphPage() {
  const [graph, setGraph] = useState<any>(null);
  const [search, setSearch] = useState('');
  const [focus, setFocus] = useState<any>(null);

  useEffect(() => { extApi.dependencyGraph().then(setGraph).catch(console.error); }, []);

  const select = async (nodeId: string) => {
    setSearch(nodeId);
    const f = await extApi.graphFocus(nodeId);
    setFocus(f);
  };

  const filtered = graph?.nodes.filter((n: any) =>
    !search || n.id.toLowerCase().includes(search.toLowerCase()) || n.label.toLowerCase().includes(search.toLowerCase())
  ) || [];

  return (
    <div>
      <h1 className="page-title">Dependency Graph</h1>
      <p className="page-subtitle">Actions → Variables → Sub-models → Macro outputs → GDP. Click to highlight upstream/downstream paths.</p>

      <div className="card" style={{ display: 'flex', gap: '0.75rem' }}>
        <input className="field" placeholder="Search variable…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      <div className="grid-2">
        <div className="card">
          <h3>Nodes ({filtered.length})</h3>
          <div style={{ maxHeight: 400, overflow: 'auto' }}>
            {filtered.map((n: any) => (
              <button key={n.id} type="button" className="graph-node-btn" onClick={() => select(n.id)}>
                <strong>{n.label}</strong> <span style={{ color: '#6b7280' }}>{n.type}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="card">
          <h3>Focus: {focus?.node_id || '—'}</h3>
          {focus && (
            <>
              <p style={{ fontSize: '0.85rem' }}><strong>Upstream:</strong> {focus.upstream.join(', ') || 'None'}</p>
              <p style={{ fontSize: '0.85rem' }}><strong>Downstream:</strong> {focus.downstream.join(', ') || 'None'}</p>
            </>
          )}
          {graph?.cycles?.length > 0 && (
            <p style={{ color: '#b91c1c', fontSize: '0.85rem' }}>Cycles: {graph.cycles.map((c: string[]) => c.join('→')).join('; ')}</p>
          )}
        </div>
      </div>
    </div>
  );
}
